<app-toasts></app-toasts>

<!-- MAIN MENU -->
<div class="container-fluid">
    <nav class="navbar navbar-fixed-sm navbar-expand-md navbar-light">
        <!-- style="height: 58px" prevents navbar from jumping/resizing when activating with mouse initially inactive navbar ; moved to CSS with @media() query-->
        <div class="navbar-header d-xs-inline col-xs-1 col-md-1 col-lg-1 mx-0 px-0">

            <!-- Hamburguer Menu for small screens -->
            <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#navbar">
                <span class="navbar-toggler-icon"></span>
            </button>
        </div>

        <div class="navbar-collapse collapse noselect" id="navbar">
            <ul ngbNav class="col-sm-12">
                <li ngbNavItem class="nav-item col-md-1 mx-1 px-0">
                    <a ngbNavLink class="mx-0 px-0" [routerLink]="['/agenda']"
                        routerLinkActive="activeLink"><span>Agenda</span></a>
                </li>

                <li ngbNavItem class="nav-item col-md-2">
                    <div class="row">
                        <div class="col">
                            <div ngbDropdown class="d-inline-block">
                                <a type="button" class="nav-link dropdown-toggle" i ngbDropdownToggle><span>{{ engLang ?
                                        "Billing": "Facturación"
                                        }}</span></a>
                                <ul ngbDropdownMenu>
                                    <li><a ngbDropdownItem [routerLink]="['/record']" routerLinkActive="activeLink"
                                            style="margin-left: 10px;"><span>{{
                                                engLang ? "Records & Claims (entry / edits)": "Records &
                                                Casos (entrada / éditos / 837)"
                                                }}</span></a></li>
                                    <li><a ngbDropdownItem [routerLink]="['/ck-register']" routerLinkActive="activeLink"
                                            style="margin-left: 10px;"><span>{{
                                                engLang ? "Received Checks & Payments Register": "Registro de Cheques y
                                                Pagos
                                                Recibidos" }}</span></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>

                <li ngbNavItem class="nav-item col-md-2">
                    <a type="button" [routerLink]="['/reports']" class="nav-link"><span>{{ engLang ?
                            "Reports":
                            "Reportes" }}</span></a>
                </li>

                <li ngbNavItem class="nav-item col-md-2">
                    <div class="row">
                        <div class="col">
                            <div ngbDropdown class="d-inline-block">
                                <a type="button" class="nav-link dropdown-toggle" ngbDropdownToggle><span>{{ engLang ?
                                        "Revsions":
                                        "Revisiones" }}</span></a>
                                <ul ngbDropdownMenu style="width: 300px;">
                                    <li *ngFor="let rev of login.revs; let e = even; let o = odd;" class="text-center"
                                        [ngClass]="{ evenRev : e, oddRev : o }">
                                        <!-- /mb/revisions/{{rev.rev}}/{{rev.rev}}.html -->
                                        <a href="{{urlDom}}{{'/mb/revisions/'}}{{rev.rev}}/{{rev.rev}}.html"
                                            target="_blank">
                                            <span class="px-0" [ngClass]="{ evenRev : e, oddRev : o }">
                                                {{ rev.rev + ' - ' + rev.dt + ' - ' + rev.descr }}
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>

                <li class="nav-item col-sm-1 ml-3 pl-3">
                    <a href="#" class="nav-link pb-0" role="button"><span>{{
                            engLang ? "Logout": "Salir" }}</span></a>
                </li>

                <li class="nav-item col-xs-1 col-md-2 mr-1 pr-0">
                    <div class="row">
                        <div class="col">
                            <div ngbDropdown class="d-inline-block">
                                <a style="color: rgb(63, 7, 92);" type="button" class="nav-link dropdown-toggle"
                                    ngbDropdownToggle><span>{{engLang ? "Services": "Servicios"}}</span>
                                    <span style="color: rgba(220, 243, 12, 0.966);">
                                        {{ (totalItems ? totalItems: ' ') }} </span>
                                    <i class="fas fa-shopping-cart"></i></a>
                                <ul ngbDropdownMenu style="width: 300px;">
                                    <li *ngFor="let item of serviceItemPrices; let idx = index"
                                        [ngStyle]="setMenuServiceItemsStyle(item, idx, totalItems)"
                                        (click)="buySomething($event);" [attr.data-modulenm]="item.module"
                                        style="margin-left: 5px; margin-right: 5px;">
                                        <a *ngIf="item.mnuShow" style="font-size: 80%;"
                                            [ngStyle]="setMenuServiceItemsStyle(item, idx, totalItems)"
                                            [attr.data-modulenm]="item.module">{{
                                            engLang ?
                                            item.mnuEng: item.mnuSpan }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>

                <li class="nav-item col-xs-1 ml-2 pl-1">
                    <a class="nav-link" (click)='toggleLanguage()' style="cursor: pointer;">
                        <span>{{ engLang ? "Español": "English" }}</span>
                    </a>
                </li>
            </ul>
        </div>
    </nav>

</div>

<div *ngIf="app_userValidLogin" class="text-center"
    style="display: flex; flex-direction: column; justify-content: center;">
    <div class="mt-1" style="height: 10px; color: maroon;">{{ _recordService.site.nm }}</div>
    <div class="mt-1" style="height: 10px; font-size: 70%;">S/N: {{ app_sn }}</div>
    <div class="my-1" style="height: 10px; font-size: 60%;"> {{ userLastNmStr }}, {{ userFirstNmStr }} ({{ userIdStr }})
    </div>
</div>

<mb-login [cust]="login.cust" [(userValidLogin)]="app_userValidLogin" [(sn)]="app_sn"></mb-login>

<div *ngIf="!app_userValidLogin" class="content">
    <div class="card-container gap-4">
        <a class="docs-card" target="_blank" rel="noopener" [href]="engLang 
        ? 'https://medicalbiller.us/about/descrEng.html'
      : 'https://medicalbiller.us/about/descrEsp.html'
  ">
            <section>{{engLang ? 'What\'s this about?' : '¿De qué se trata esto?'}}</section>

            <section style="background-color: #f1f5f9;;">
                <svg class="material-icons py-0" xmlns="http://www.w3.org/2000/svg" height="20px"
                    viewBox="0 -960 960 960" width="20px" fill="#1f1f1f">
                    <path
                        d="M480-240q20 0 34-14t14-34q0-20-14-34t-34-14q-20 0-34 14t-14 34q0 20 14 34t34 14Zm-36-153h73q0-37 6.5-52.5T555-485q35-34 48.5-58t13.5-53q0-55-37.5-89.5T484-720q-51 0-88.5 27T343-620l65 27q9-28 28.5-43.5T482-652q28 0 46 16t18 42q0 23-15.5 41T496-518q-35 32-43.5 52.5T444-393Zm36 297q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
                </svg>
            </section>

            <span class="card-footer">{{engLang ? 'Discover MedicalBiller in 60 secs.' : 'Descubra el MedicalBiller en
                60
                segs.'}}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                </svg>
            </span>
        </a>

        <a class="docs-card" target="_blank" rel="noopener"
            href="https://medicalbiller.us/about/demos-index.html?engLang={{engLang}}">
            <section>{{engLang ? 'How does it do it?' : '¿Cómo lo hace?'}}</section>

            <section style="background-color: #f1f5f9;;">
                <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960"
                    width="20px" fill="#1f1f1f">
                    <path
                        d="M144-144v-48h96v-24h-48v-48h48v-24h-96v-48h120q10.2 0 17.1 6.9 6.9 6.9 6.9 17.1v48q0 10.2-6.9 17.1-6.9 6.9-17.1 6.9 10.2 0 17.1 6.9 6.9 6.9 6.9 17.1v48q0 10.2-6.9 17.1-6.9 6.9-17.1 6.9H144Zm0-240v-96q0-10.2 6.9-17.1 6.9-6.9 17.1-6.9h72v-24h-96v-48h120q10.2 0 17.1 6.9 6.9 6.9 6.9 17.1v72q0 10.2-6.9 17.1-6.9 6.9-17.1 6.9h-72v24h96v48H144Zm48-240v-144h-48v-48h96v192h-48Zm168 384v-72h456v72H360Zm0-204v-72h456v72H360Zm0-204v-72h456v72H360Z" />
                </svg>
            </section>

            <span class="card-footer">Demos
                <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    viewBox="0 0 24 24">
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                </svg>
            </span>
        </a>

        <a class="docs-card" target="_blank" rel="noopener" href="https://medicalbiller.us/about/ComingSoon.html">
            <section>{{engLang ? 'Buy it...' : 'Cómpralo...'}}</section>

            <section style="background-color: #f1f5f9;;">
                <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960"
                    width="20px" fill="#1f1f1f">
                    <path
                        d="M263.79-96Q234-96 213-117.21t-21-51Q192-198 213.21-219t51-21Q294-240 315-218.79t21 51Q336-138 314.79-117t-51 21Zm432 0Q666-96 645-117.21t-21-51Q624-198 645.21-219t51-21Q726-240 747-218.79t21 51Q768-138 746.79-117t-51 21ZM253-696l83 192h301l82-192H253Zm-31-72h570q14 0 20.5 11t1.5 23L702.63-476.14Q694-456 676.5-444T637-432H317l-42 72h493v72H276q-43 0-63.5-36.15-20.5-36.16.5-71.85l52-90-131-306H48v-72h133l41 96Zm114 264h301-301Z" />
                </svg>
            </section>

            <span class="card-footer">
                <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    viewBox="0 0 24 24">
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                </svg>
            </span>
        </a>

    </div>

    <footer class="content">
        <p>Copyright © 2025 JLRosado All rights reserved.</p>
    </footer>
</div>


<!-- ================ PAYMENT FORM ============================================================== -->

<!-- modal payments credited to claims per check ......................................................................................... -->
<ng-template #paymentDlgShowModal let-modal>
    <div class="modal-header" style="background-color: #A2C4C0;">

        <div class="rowBox">
            <div>
                <span *ngIf="!engLang" style="font-size: 95%;">Forma de Pago
                </span>
                <span *ngIf="engLang" style="font-size: 95%;">Payment Form </span>
            </div>

            <span *ngIf="waiting4Response">
                <img src="../app/assets/images/waiting4Response.gif" width="50" height="25" alt="Waiting">
            </span>

            <div class="btn-group">
                <button class="btn btn-primary active" id="credCard" (click)="onCcAchClick($event.target)"
                    [disabled]="ccDisabled">{{engLang ? "Credit Card": "Tarjeta Crédito"}}</button>
                <button class="btn btn-warning" id="achTxfer" (click)="onCcAchClick($event.target)"
                    [disabled]="achDisabled">{{engLang ? "Bank Debit": "Débito Banco"}}</button>
            </div>

            <div>
                <span *ngIf="type == 'cc'">
                    <img src="../app/assets/images/allowedcards.jpg" width="125" height="30" alt="Credit Cards">
                </span>
                <span *ngIf="type == 'cc'">{{engLang ? "Credit Card Charge": "Tarjeta de Crédito"}}</span>

                <span *ngIf="type == 'ach'">
                    <img src="../app/assets/images/ach_check.png" width="55" height="30" alt="Check">
                </span>
                <span *ngIf="type == 'ach'">{{engLang ? "ACH Bank Debit": "Directo de Cuenta de Banco"}}
                </span>
            </div>

            <!-- <div>
                <pre>{{ totalItems }}</pre>
            </div> -->

        </div>


        <button type="button" class="btn btn-sm btn-close"
            (click)="modal.dismiss('close_paymentDlgShowModal')"></button>
    </div>

    <div class="modal-body">

        <payment-form [customer]="cust" [serviceItemPrices]="serviceItemPrices" [total]="total"
            [totalItems]="totalItems" [type]="type" [engLang]="engLang" [userValidLogin]="app_userValidLogin">
        </payment-form>

    </div>

    <div class="modal-footer" style="display: flex; justify-content: space-between;">
        <div style="font-size: 70%; flex-basis: 50%;">
            {{ engLang ? 'Esc - Close': 'Esc - Cerrar' }}
        </div>
        <div>
            <button type="button" class="btn btn-outline-dark" style="font-size: 65%;"
                (click)="modal.close('oK_paymentDlgShowModal')">{{ engLang ? " Select more services": "Seleccionar más
                servicios" }}</button>
        </div>
    </div>
</ng-template>

<!-- <pre>cust.sn</pre>
<pre>{{ cust.sn }}</pre> -->